import { lazy, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'

const ScreenerPage = lazy(() => import('@/pages/etf/list'))
const ETFDetailPage = lazy(() => import('@/pages/etf/item'))
const ETFComparisonPage = lazy(() => import('@/pages/etf/comparison'))
const BlogIndexPage = lazy(() => import('@/pages/blog/index'))
const BlogSearchPage = lazy(() => import('@/pages/blog/search'))
const BlogBookmarksPage = lazy(() => import('@/pages/blog/bookmarks'))
const BlogCategoryPage = lazy(() => import('@/pages/blog/category'))
const BlogItemPage = lazy(() => import('@/pages/blog/item'))
const NewsIndexPage = lazy(() => import('@/pages/news'))
const AuthorPage = lazy(() => import('@/pages/author/item'))

// About pages
const AboutUsPage = lazy(() => import('@/pages/about/about-us'))
const PrivacyPolicyPage = lazy(() => import('@/pages/about/privacy-policy'))
const TermsOfUsePage = lazy(() => import('@/pages/about/terms-of-use'))
const EditorialPolicyPage = lazy(() => import('@/pages/about/editorial-policy'))
const DisclaimerPage = lazy(() => import('@/pages/about/disclaimer'))
const CookiePolicyPage = lazy(() => import('@/pages/about/cookie-policy'))

// Assistance pages
const ContactPage = lazy(() => import('@/pages/assistance/contact'))
const FAQPage = lazy(() => import('@/pages/assistance/faq'))

import Error404 from '@/components/common/Error404'
import MainLayout from '@/components/layouts/MainLayout'
import MainLayoutWithoutMobilePadding from '@/components/layouts/MainLayoutWithoutMobilePadding'
import { Center,Loader, Stack, Text } from '@mantine/core'

import { useUserContext } from './context/UserContext'

const PageLoader = () => (
  <Center h="60vh">
    <Loader size="lg" />
  </Center>
)

const AppRoutes = () => {
  const location = useLocation()
  const { user, loading } = useUserContext()

  useEffect(() => {
    // Ensure fetching logic runs when location changes
    // console.log('Current location:', location.pathname)
  }, [location])

  // console.log('user:', user, 'loading:', loading)
  return loading ? (
    <Center h="100vh">
      <Stack align="center">
        <Loader size="lg" />
        <Text>Loading</Text>
      </Stack>
    </Center>
  ) : (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* News pages with special layout */}
        <Route path="/" element={<MainLayoutWithoutMobilePadding><NewsIndexPage /></MainLayoutWithoutMobilePadding>} />
        <Route path="/news" element={<MainLayoutWithoutMobilePadding><NewsIndexPage /></MainLayoutWithoutMobilePadding>} />

        {/* All other pages with regular layout */}
        <Route path="/*" element={
          <MainLayout>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/screener" element={<ScreenerPage />} />
                <Route path="/etf/:id" element={<ETFDetailPage />} />
                <Route path="/etf/comparison" element={<ETFComparisonPage />} />
                <Route path="/blog" element={<BlogIndexPage />} />
                <Route path="/blog/search" element={<BlogSearchPage />} />
                <Route path="/blog/bookmarks" element={<BlogBookmarksPage />} />
                <Route path="/blog/category/:slug" element={<BlogCategoryPage />} />
                <Route path="/blog/:slug" element={<BlogItemPage />} />
                <Route path="/author/:slug" element={<AuthorPage />} />

                {/* About pages */}
                <Route path="/about/about-us" element={<AboutUsPage />} />
                <Route path="/about/editorial-policy" element={<EditorialPolicyPage />} />
                <Route path="/about/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/about/terms-of-use" element={<TermsOfUsePage />} />
                <Route path="/about/disclaimer" element={<DisclaimerPage />} />
                <Route path="/about/cookie-policy" element={<CookiePolicyPage />} />

                {/* Assistance pages */}
                <Route path="/assistance/contact" element={<ContactPage />} />
                <Route path="/assistance/faq" element={<FAQPage />} />

                {/* 404 page for unmatched routes */}
                <Route path="*" element={<Error404 />} />
              </Routes>
            </Suspense>
          </MainLayout>
        } />
      </Routes>
    </Suspense>
  )
}

export default AppRoutes
